import React from 'react';
import { Link } from 'react-router-dom';
import Username from './../common/Username';
import Avatar from './../common/Avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChrome, faFirefox, faOpera, faInternetExplorer, faEdge, faSafari, faSteam, faDiscord } from '@fortawesome/free-brands-svg-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const browserDetect = (location, browser) => {
    if (browser && location) {
        if (browser.search("Chrome") > 0) {
            return (
                <OverlayTrigger placement="top" overlay={<Tooltip id="users-online-location">Browsing {location}</Tooltip>}>
                    <Link to={location}><FontAwesomeIcon className="text-primary" icon={faChrome} fixedWidth/></Link>
                </OverlayTrigger>
            );
        }
        else if (browser.search("Edge") > 0) {
            return (
                <OverlayTrigger placement="top" overlay={<Tooltip id="users-online-location">Browsing {location}</Tooltip>}>
                    <Link to={location}><FontAwesomeIcon className="text-primary" icon={faEdge} fixedWidth/></Link>
                </OverlayTrigger>
            );
        }
        else if (browser.search("MSIE") > 0) {
            return (
                <OverlayTrigger placement="top" overlay={<Tooltip id="users-online-location">Browsing {location}</Tooltip>}>
                    <Link to={location}><FontAwesomeIcon className="text-primary" icon={faInternetExplorer} fixedWidth/></Link>
                </OverlayTrigger>
            );
        }
        else if (browser.search("Firefox") > 0) {
            return (
                <OverlayTrigger placement="top" overlay={<Tooltip id="users-online-location">Browsing {location}</Tooltip>}>
                    <Link to={location}><FontAwesomeIcon className="text-primary" icon={faFirefox} fixedWidth/></Link>
                </OverlayTrigger>
            );
        }
        else if (browser.search("Safari") > 0) {
            return (
                <OverlayTrigger placement="top" overlay={<Tooltip id="users-online-location">Browsing {location}</Tooltip>}>
                    <Link to={location}><FontAwesomeIcon className="text-primary" icon={faSafari} fixedWidth/></Link>
                </OverlayTrigger>
            );
        }
        else if (browser.search("Opera") > 0) {
            return (
                <OverlayTrigger placement="top" overlay={<Tooltip id="users-online-location">Browsing {location}</Tooltip>}>
                    <Link to={location}><FontAwesomeIcon className="text-primary" icon={faOpera} fixedWidth/></Link>
                </OverlayTrigger>
            );
        } else {
            return null
        }
    }
};

const steamStatusCode = (code) => {
    switch(code) {
        case 1:
            return 'Online';
        case 2:
            return 'Busy';
        case 3:
            return 'Away';
        case 4:
            return 'Snooze';
        case 5:
            return 'Looking to trade';
        case 6:
            return 'Looking to play';
        default:
            return null;
    }
};

const discordGameTypeCode = (code) => {
    switch(code) {
        case 0:
            return 'Playing ';
        case 1:
            return 'Streaming ';
        case 2:
            return 'Listening to ';
        default:
            return null;
    }
};

const UserOnlineUser = (props) => (
    <li className="list-group-item users-list-group-item">
        <div className="pull-left">
            <Avatar image={props.user.avatar} rank={props.ranks[props.user.rank]} width="25" height="25" />
        </div>
        <span className="users-list-user"><Username user={props.user} rank={props.ranks[props.user.rank]} /></span>
        <div className="pull-right icons">
            {(props.user.discordStatus) ? (
                <OverlayTrigger placement="top" overlay={<Tooltip id="users-online-steam">
                    <div>{props.user.discordStatus.toProperCase()}</div>
                    <div>{discordGameTypeCode(props.user.discordGameType)}{props.user.discordGame}</div>
                    {props.user.discordLocation? (<div>In Channel {props.user.discordLocation}</div>) : (null)}
                </Tooltip>}>
                    {props.user.discordUrl ? (
                        <a target="_blank" href={props.user.discordUrl}>
                            <FontAwesomeIcon className="text-primary" icon={faDiscord} fixedWidth />
                        </a>
                        ): (<FontAwesomeIcon className="text-primary" icon={faDiscord} fixedWidth />)}
                </OverlayTrigger>
            ) : (null)}
            {(props.user.steamStatus) ? (
                <OverlayTrigger placement="top" overlay={<Tooltip id="users-online-steam"><div>{steamStatusCode(props.user.steamStatus)}</div><div>{props.user.steamGame}</div></Tooltip>}>
                    <FontAwesomeIcon className="text-primary" icon={faSteam} fixedWidth />
                </OverlayTrigger>
            ) : (null)}
            {browserDetect(props.user.browserLocation, props.user.browser)}
        </div>
    </li>
);


export default UserOnlineUser;


// WEBPACK FOOTER //
// ./src/UsersOnline/UserOnlineUser.js